import { onready, onload } from './utils.js';

var nextTalkId = 1;

function renderAndThen(action) {
  setTimeout(action, 1);
}

function onLoadStarted() {
  return document.querySelector("h1").insertAdjacentHTML(
    "beforeend",
    '<span class="loading-text" style="font-size: 14px; font-weight: normal; color: #999;"> (loading...)</span>'
  );
}

function onLoadFinished() {
  document.querySelector('.loading-text').remove();
  var onLoadFinishedEvent = new CustomEvent("playbuttonsloaded");
  document.dispatchEvent(onLoadFinishedEvent);
}

function getStreamControlHtml(link) {
  var html = '<audio controls autoplay src="' + link + '" class="play"></audio>';
  return html;
}

function getButtonsHtml(link) {
  var html = '<button class="play" data-active="false" data-link="' + link + '"><span class="visually-hidden">Play Audio</span></button>';
  return html;
}

function markVisited(link) {
  currentUrl = window.location.href;
  history.replaceState({}, "", link);
  history.replaceState({}, "", currentUrl);
}

function forceVisitedOnDownload(link) {
  // now that we're done operating on all li tags...
  // force mark visited on forced-downoad links.
  // note that this must happen after our previous
  // operation completes, because it's the one that
  // actually adds the 'download-mark-visited' class
  // to the elements. If we don't wait, we might
  // miss a lot of elements that haven't been marked yet.
  return link.addEventListener("click", function() {
    // whenever a link with a 'download-mark-visited' class is clicked,
    // we want to force the browser to see it as visited
    // note that now $(this) is each link we're operating on.
    markVisited(link.getAttribute('href'));
  });
}

function initializeListItem(element) {
  // get the anchor tag defined inside it
  var anchor = element.querySelector('a.audio');
  // get its link/url
  var link = anchor.getAttribute('href');
  element.classList.add('li-audio');
  // force it to download when clicked
  forceVisitedOnDownload(anchor);
  // now add some buttons before the anchor tag.
  var button = element.querySelector("button.play");
  if (button == null) {
    element.insertAdjacentHTML("afterbegin", getButtonsHtml(link));
    button = element.children[0];
    anchor.setAttribute('download', '');
  }
  setupPlayButton(button);
}

function setupPlayButton(button) {
  // for each button with class play, add the
  // following on-click handler (read: behavior).
  return button.addEventListener("click", function() {
    // heuristic: find its containing li tag.
    var li = button.parentElement;

    // toggle play/stop image.
    //
    // 1) if the image has a data-active attribute (which we're adding
    // in the following 'else' clause), then we know that if clicked
    // again, it means we want to stop it, because the first click
    // which made data-active equal true was the one that got it to play.
    if (button.getAttribute('data-active') === 'true') {
      // remove the streaming audio element from the page.
      li.querySelector('audio').remove();
      // it's not active anymore, so we need to set data-active
      // to false in order to maintain a correct state of things
      // for the next click(s).
      button.setAttribute('data-active', 'false');
      button.classList.remove('playing');
    }
    // 2) if it either didn't have a data-active attribute, or it was
    // set to false, then we know that the click we're handling now
    // should make it play the audio.
    else {
      // to maintain a correct state, set data-active to true.
      button.setAttribute('data-active', 'true');
      // get the link/url for the talk.
      var link = button.getAttribute('data-link');
      // change our image to a stop icon.
      button.classList.add('playing');
      // add the streaming audio element.
      li.insertAdjacentHTML("beforeend", getStreamControlHtml(link));
      var audio = li.lastElementChild;
      // make sure to set played talks as visited links.
      // we do this by getting the just-added audio tag
      // inside the current operated-on <li>, and binding
      // its built-in "timeupdate" event to a custom handler,
      // in which we...
      function onTimeUpdate() {
        // get the current time position in the audio.
        var t = audio.currentTime;
        // get the url of the talk from the audio tag's src attribute.
        var talkUrl = audio.getAttribute("src");

        // and only if it's been played for over 10 seconds...
        if (t >= 10) {
          markVisited(talkUrl);
          // now we don't need this timeupdate event firing all the time,
          // costing us in computation, since we've done what we wanted
          // to do with it.
          audio.removeEventListener('timeupdate', onTimeUpdate);
        }
      }
      audio.addEventListener('timeupdate', onTimeUpdate);
    }
  });
}

function ready(callback) {
  if (document.readyState != "loading") {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
}

// wait until the document is ready before we start operating on its
// content.
function setupTalkButtons() {
  // find li tags containing talks by the heuristic that they're the
  // parent of elements with class 'audio'.
  var audioElements = Array.from(document.querySelectorAll(".audio"));
  // preprocess some items in order to increase perceived performance
  // (visually).
  var preprocessedItemCount = 100;
  var preprocessElements = audioElements.slice(0, preprocessedItemCount);
  preprocessElements.forEach((element) => initializeListItem(element.parentElement));
  onLoadStarted();
  renderAndThen(function() {
    audioElements.slice(preprocessedItemCount)
      .forEach(function(element) {
        var li = element.parentElement;
        initializeListItem(li);
      });
      onLoadFinished();
  });
}

function bisectLeft(arr, x) {
  var lo = 0;
  var hi = arr.length;
  var mid;
  while (lo < hi) {
    mid = Math.floor((lo + hi) / 2);
    if (arr[mid] < x) {
      lo = mid + 1;
    } else {
      hi = mid;
    }
  }
  return lo;
}

function randomNumber(max) {
  return Math.floor(Math.random() * max + 1);
}

function playTalk(talkNum) {
  var audioButtons = document.querySelectorAll('.li-audio .play');
  var nthButton = audioButtons[audioButtons.length - talkNum];
  var clickEvent = new MouseEvent("click", {bubbles: true});
  nthButton.dispatchEvent(clickEvent);
  nthButton.scrollIntoView({block: "center"});
}

function setupRandomTalk(initYear, thisYear, baseUrl, yearCounts) {
  function playRandomTalk() {
    var id = randomNumber(yearCounts[yearCounts.length - 1]);
    var idx = bisectLeft(yearCounts, id);
    var year = initYear + idx;
    var countOffset = yearCounts[idx - 1] || 0;
    var idInYear = id - countOffset;

    if (year != thisYear) {
      window.location = baseUrl + year + "/#randomId=" + idInYear;
    } else {
      playTalk(idInYear);
    }
  }

  document.addEventListener("playbuttonsloaded", function() {
    var params = new URLSearchParams(window.location.hash);
    if (params.has("#randomId")) {
      playTalk(Number(params.get("#randomId")));
    } else if (params.has('#random')) {
      playRandomTalk();
    }
  });

  onready(function () {
    document.getElementById('randomTalkButton').addEventListener("click", function (event) {
      event.preventDefault();
      playRandomTalk();
    });
  });
}

export { setupTalkButtons, setupRandomTalk };
// Local Variables:
// js-indent-level: 2
// End:
